import React, { FC, useEffect } from 'react';
import Box from '@sendsprint/ui-react/dist/components/Box';
import Button from '@sendsprint/ui-react/dist/components/Button';
import Text from '@sendsprint/ui-react/dist/components/Text';
import useId from '@sendsprint/ui-react/dist/hooks/useId';
import { PhoneNumberImage } from './assets';
import { useFormikContext } from 'formik';
import { useAccount } from '@src/contexts';
import Dialog2 from '@src/components/dialog2';
import OtpScreen from './components/otpScreen';
import CloseBtn from '../closeBtn';
import { StepsForPhoneUpdateI } from '@src/hooks/utils/useAddressUpdate';

export interface UpdatePhoneNumberData {
  phone: string;
  captcha?: string;
  otp?: string;
}

interface Props {
  state: boolean;
  changePhoneNumber?: () => void;
  handlePhoneNumberClose: () => void;
  phoneUpdateLoading?: boolean;
  verifyStatus?: boolean | null;
  stepsForPhoneUpdate?: StepsForPhoneUpdateI;
  counter: number;
  handleStartTimer: () => void;
  isStarted: boolean;
  queryValues?: {
    email: string | null;
    hash: string | null;
  };
}

const OtpModal: FC<Props> = ({
  state,
  stepsForPhoneUpdate,
  changePhoneNumber,
  phoneUpdateLoading,
  verifyStatus,
  handlePhoneNumberClose,
  counter,
  handleStartTimer,
  isStarted,
  queryValues
}) => {
  const titleId = useId();
  const { user } = useAccount();
  const { submitForm } = useFormikContext();

  useEffect(() => {
    if (stepsForPhoneUpdate !== 'initial' && counter > 0) {
      if (handleStartTimer) {
        handleStartTimer();
      }
    }
  }, [stepsForPhoneUpdate]);

  const submit = () => {
    submitForm();
  };

  return (
    <Dialog2 isOpen={state} handleClose={() => null} aria-labelledby={titleId} disableOverlayClick>
      <Box className="ss-flex ss-justify-between ss-mb-6 ss-gap-4 ss-items-center">
        <Text className="ss-text-neutral-500 ss-flex-1" variant="h5">
          Phone Number Verification
        </Text>
        <CloseBtn onClick={handlePhoneNumberClose} />
      </Box>
      <Box className="ss-bg-white ss-p-4 ss-rounded-lg ss-mb-6">
        <div className="ss-text-center ss-bg-neutral-5 ss-flex ss-justify-center ss-py-12">
          <img src={PhoneNumberImage} className="ss-w-36" alt="phone" />
        </div>
        <Box className="ss-max-w-4xl ss-mx-auto">
          <div className="ss-mb-10 ss-space-y-4">
            <OtpScreen
              changePhoneNumber={changePhoneNumber}
              counter={counter}
              user={user}
              verifyStatus={verifyStatus}
              handleStartTimer={handleStartTimer}
              isStarted={isStarted}
              queryValues={queryValues}
            />
          </div>
          <div className="ss-space-y-6"></div>
        </Box>
      </Box>
      <Box className="ss-text-center ss-max-w-4xl ss-mx-auto">
        <Button
          className="ss-mb-6"
          label="Verify phone number"
          variant="primary"
          type="button"
          onClick={submit}
          isBlock={true}
          showSpinner={phoneUpdateLoading}
          disabled={phoneUpdateLoading}
        />
      </Box>
    </Dialog2>
  );
};

export default OtpModal;
